<template>
  <div id="bedroomMin" class="d-flex align-items-center">
    <h5 class="mb-0">
      et au moins
    </h5>
    <multiselect
      ref="multiselect"
      :class="{ 'border-bottom-blue': isBedroomMinSet && !isBedroomMinOpened }"
      v-model="bedroomMinValue"
      :options="bedroomMinOptions"
      placeholder="2 chambres"
      :searchable="false"
      :multiple="false"
      :max-height="200"
      label="label"
      :allow-empty="false"
      :close-on-select="true"
      :show-labels="false"
      open-direction="bottom"
      @close="setIsBedroomMinOpened(false)"
      @open="setIsBedroomMinOpened(true)"
      ><span
        class="caret"
        slot-scope="{ toggle }"
        :class="{ 'border-blue': isBedroomMinSet }"
        @mousedown.prevent.stop="toggle"
        slot="caret"
      ></span
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapMutations, mapGetters, mapState } from "vuex";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      bedroomMinOptions: [
        { id: 0, label: "0 chambre" },
        { id: 1, label: "1 chambre" },
        { id: 2, label: "2 chambres" },
        { id: 3, label: "3 chambres" },
        { id: 4, label: "4 chambres" },
      ],
    };
  },
  computed: {
    ...mapState(["isBedroomMinOpened"]),
    ...mapGetters(["isBedroomMinSet"]),
    bedroomMinValue: {
      get() {
        /*** VALUE TO OBJECT ***/
        let value = this.$store.state.userSearch.bedroomMin;
        return this.bedroomMinOptions.find(obj => {
          return obj.id === value;
        });
      },
      set(value) {
        /*** OBJECT TO VALUE ***/
        this.$store.commit("SET_BEDROOMS", value.id);
      },
    },
  },
  methods: {
    ...mapMutations({ setIsBedroomMinOpened: "SET_IS_BEDROOM_MIN_OPENED" }),
    focus() {
      this.$refs.multiselect.$el.focus();
    },
  },
  mounted() {
    if (this.$router.currentRoute.name != "dashboard") this.focus();
    this.$store.commit("SET_HAS_INPUT_BEEN_CHANGED", false);
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/multiselect.scss";
@import "@/styles/transitions.scss";
.multiselect {
  width: 15rem;
  margin-left: 1rem;
}
</style>
